import { Component } from '@angular/core';

import { LeftSidebarService } from '../../Common/Layout/services/left-sidebar.service';
import { LeftSidebarManagementService } from '../../Common/Layout/services/left-sidebar-management.service';
import { ViLeftSidebarService } from '../services/vi-left-sidebar.service';
import { ViLeftSidebarManagementService } from '../services/vi-left-sidebar-management.service';
import { AbstractHypeService } from '../../Common/Layout/services/abstract-hype.service';
import { ViHypeService } from '../services/vi-hype.service';

@Component({
    selector: 'agpr-visibility-intelligence',
    templateUrl: './visibility-intelligence.component.html',
    providers: [
        {
            provide: AbstractHypeService,
            useClass: ViHypeService
        },
        {
            provide: LeftSidebarService,
            useExisting: ViLeftSidebarService
        },
        {
            provide: LeftSidebarManagementService,
            useExisting: ViLeftSidebarManagementService
        }
    ],
    standalone: false
})
export class VisibilityIntelligenceComponent {
    constructor() {}
}
